document.addEventListener('DOMContentLoaded', () => {
    const values = document.querySelectorAll('.fps-value');

    const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
            if (!entry.isIntersecting) return;
            run(entry.target);
            observer.unobserve(entry.target);
        });
    }, { threshold: 0.2 });

    values.forEach(v => observer.observe(v));
    });

    function run(el) {
    const target = Number(el.dataset.value);
    let current = 0;

    const duration = 1000;
    const step = 16;
    const increment = target / (duration / step);

    const tick = () => {
        current += increment;
        if (current >= target) {
            el.textContent = target;
            return;
        }
        el.textContent = Math.floor(current);
        requestAnimationFrame(tick);
    };

    requestAnimationFrame(tick);
}
